import { useId } from 'react'
import { useTranslation } from 'react-i18next'

import { AlertCircle } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

import { getMessage } from './utils'

export type ErrorDisplayProps = {
  error: unknown
}

export const ErrorDisplay = ({ error }: ErrorDisplayProps) => {
  const { t } = useTranslation()
  const message = getMessage(error)
  const titleId = useId()

  return (
    <div className="flex p-4 h-full items-center justify-center">
      <Alert
        variant="destructive"
        className="w-full max-w-2xl"
        aria-labelledby={titleId}
      >
        <AlertCircle className="h-4 w-4" />
        <AlertTitle id={titleId}>
          <h3>{t('common.error')}</h3>
        </AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    </div>
  )
}
